import { Button } from '@/ui/Button';
import { ButtonGroup } from '@/ui/ButtonGroup';
import { useLearnerCourseHref } from '@/features/course/learner/hooks/useLearnerCourseNavigate';

type StartAdminButtonGroupProps = {
  course: {
    id: number;
    title: string;
  };
  editUrl?: string;
};

export const StartAdminButtonGroup = ({ course, editUrl }: StartAdminButtonGroupProps): JSX.Element => {
  const href = useLearnerCourseHref();
  const insightsUrlHref = href.adminInsightsHref(course.id);

  return (
    <ButtonGroup>
      <Button
        variant="secondary"
        to={insightsUrlHref}
        rel="noopener noreferrer"
        icon={['far', 'poll']}
        $iconPosition="start"
        size="large"
      >
        Insights
      </Button>
      {editUrl && (
        <Button
          variant="secondary"
          to={editUrl}
          rel="noopener noreferrer"
          icon={['far', 'edit']}
          $iconPosition="start"
          size="large"
        >
          Edit
        </Button>
      )}
    </ButtonGroup>
  );
};
